// extracted by mini-css-extract-plugin
export var chip = "_5h-9";
export var chipLabel = "_5h-a";
export var close = "_5h-7";
export var closeIcon = "_5h-8";
export var error = "_5h-6";
export var infoTooltip = "_5h-2";
export var innerContainer = "_5h-1";
export var input = "_5h-b";
export var medium = "_5h-5";
export var outerContainer = "_5h-0";
export var small = "_5h-4";
export var xSmall = "_5h-3";